import { render, staticRenderFns } from "./DefaultTable.vue?vue&type=template&id=7cb26926&scoped=true"
import script from "./DefaultTable.vue?vue&type=script&lang=js"
export * from "./DefaultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb26926",
  null
  
)

export default component.exports